import React from 'react';
import { Dialog,Box, Avatar} from '@mui/material';
import { styled } from '@mui/material/styles'; 
import BtnPrimary from "./PrimaryButton";
import GreenTick from "../assets/images/green-checkmark-filled-bordered.png";
import { useNavigate } from 'react-router';
import BtnSecondary from './SecondaryButton';

import { tokens, displayFont } from "../theme";
const TextBox = styled(Box)({
    width:"100%"
});

function SuccessDialog({open, onClose, message, addNewLink, addNewText, viewAllLink, viewAllText}) {
  
  const navigate = useNavigate();

  const handleAddNew = () => {
       onClose();
       navigate(addNewLink);
  }

  const handleViewAll = () => {
       onClose();
       if (typeof viewAllLink === 'function') {
            viewAllLink();
        } else {
            navigate(viewAllLink);
        }
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width:"36.625rem",
          borderRadius: "8px",
          boxShadow: "0 4px 12px -4px rgba(42,29,34,0.16)",
          padding: "2.5rem 1.5rem",
          display:"flex",
          flexDirection:"column",
          alignItems:"center",
        }
      }}
    >
        
            <Avatar src={GreenTick} alt="icon" sx={{height:"7rem", width:"7rem"}}/>
            <TextBox sx={{fontFamily: displayFont, fontWeight: 600, fontSize: "1.25rem", lineHeight: 1.3, color: tokens.textMuted, marginTop: "1.5rem", textAlign:"center"}}>
              {message}
            </TextBox>
            <Box sx={{
                width:"100%", 
                display:"flex",
                justifyContent:viewAllText && addNewText?"space-between":"center", 
                marginTop: "2.5rem"
            }}>
                {viewAllText && (
                  <BtnSecondary 
                    onClick={handleViewAll}
                    sx={{ width: "15.56rem", height: '3.5rem', padding: '1rem', borderRadius: '8px', backgroundColor: "#F5E9E1" }}
                  >
                    {viewAllText}
                  </BtnSecondary>
                )}
                {addNewText && (
                  <BtnPrimary 
                    onClick={handleAddNew}
                    sx={{ width: "15.56rem", height: '3.5rem', padding: '1rem', borderRadius: '8px' }}
                  >
                    {addNewText}
                  </BtnPrimary>
                )}
            </Box>
    </Dialog>
  );
}

export default SuccessDialog;

